<div class="pipeline-section">
  <div class="pipeline-heading-wrapper">
    <p class="pipeline-label">The Sales Journey</p>
    <h2 class="pipeline-heading">From First Contact to Closed Deal</h2>
    <p class="pipeline-subtitle">
      Every customer moves through the same four stages — see exactly where each one stands, at all times.
    </p>
  </div>

  <div class="pipeline-track">
    <div class="pipeline-stage" *ngFor="let stage of stages; let i = index; let last = last">
      <div class="pipeline-node">
        <span class="pipeline-node-number">{{ i + 1 }}</span>
        <span class="pipeline-node-icon">{{ stage.icon }}</span>
      </div>
      <h3 class="pipeline-stage-title">{{ stage.title }}</h3>
      <p class="pipeline-stage-desc">{{ stage.desc }}</p>
      <span class="pipeline-arrow" *ngIf="!last" aria-hidden="true">&#8594;</span>
    </div>
  </div>
</div>
